import React from "react";
import { useFeatureCardStyles } from "./FeatureCardStyles";
import { MBox, MChip, MLink, MTypography, MIcons } from "@material-dev/insights-portal-ui-components";
import { CardDetails } from "../Types/types";

export type FeatureCardProps = CardDetails & {
  tagClassName?: string;
}

const FeatureCard = ({ title, badge, hyperLink, tagClassName }: FeatureCardProps) => {
  const { cx, classes } = useFeatureCardStyles();

  return (
    <MBox className={classes.root}>
      <MBox className={classes.container}>
        <MBox className={classes.badgesection}>{badge && <MChip className={cx(classes.badge, tagClassName)} label={badge} />}</MBox>
        <MTypography className={classes.title} noWrap>{title}</MTypography>
        <MBox className={classes.actions}>
          <MLink
            href={hyperLink}
            target='_blank'
            rel='noopener noreferrer'
            underline="hover"
            className={classes.externalLink}
          >
            <MIcons.ExtLinkIcon className={classes.externalLinkIcon} />
          </MLink>
        </MBox>
      </MBox>
    </MBox>
  );
};

export default FeatureCard;
